<template>
  <img :src="img" >
</template>
<script>
  import { getImg } from '../../general'
  import mime_types from '../../mime_types.json'

export default {
  data(){
    return {
      img: ''
    }
  },
  props: {
    url: String
  },
  async mounted(){
    this.img = await this.getImgURL(this.url)
  },
  methods: {
    _arrayBufferToBase64(buffer) {
      var strData = '';
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          strData += String.fromCharCode(bytes[i]);
      }
      strData = window.btoa(strData)

      return strData
    },
    async getImgURL(path){
      try {
        const response = await getImg(this, path)
        const binaryData = await response.arrayBuffer()
        // const base64 = window.btoa(String.fromCharCode(...new Uint8Array(binaryData)))
        const base64 = this._arrayBufferToBase64(binaryData)
        const fileExtention = path.split('.').at(-1)
        const mimeType = mime_types.find(mime_type => mime_type.extention === `.${fileExtention.toLowerCase()}`)
        const img = `data:${mimeType.mime_type};base64,${base64}`

        return img
      } catch (error) {
        console.log("Error cargando la imagen");
        console.log(error)
      }
    }
  }
}
</script>
